module.exports = __webpack_public_path__ + "static/img/13.06c53d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/13.png
// module id = HbbQ
// module chunks = 0